import React from "react"
import Header from "../components/header"
import Layout from "../components/layout";

export default ({location}) => (
    <Layout location={location}>
        <div >
            <Header headerText="Contact"/>
            <p><a href="mailto:mydayforfuture@gmx.de">MyDayForFuture</a></p>
        </div>
    </Layout>
)

